import { render } from "./SupplierInvoicesView.vue?vue&type=template&id=158156a0&scoped=true"
import script from "./SupplierInvoicesView.vue?vue&type=script&lang=js"
export * from "./SupplierInvoicesView.vue?vue&type=script&lang=js"

import "./SupplierInvoicesView.vue?vue&type=style&index=0&id=158156a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158156a0"]])

export default __exports__